// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__9SnjI","notes":"Notes_notes__3rh0T","note":"Notes_note__1IzNC","markdown":"Notes_markdown__23pv2"};